import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { rialId } from "../services/bags";
import { contextApi } from "../context/contextApi";

export function useWalletAssets(defaultType) {
  const [searchParams] = useSearchParams();
  const type = Number(searchParams.get("type")) || defaultType;
  const { setLoad } = useContext(contextApi);
  const [boxes, setBoxes] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const fetchAssets = async () => {
      setLoad?.(true);
      try {
        const res = await rialId(type);
        if (cancelled) return;

        const data = res?.data?.data;
        setBoxes(Array.isArray(data) && data.length > 0 ? data : []);
      } catch {
        if (!cancelled) setBoxes([]);
      }
      setLoad?.(false);
    };

    fetchAssets();

    return () => {
      cancelled = true;
    };
  }, [type, setLoad]);

  return { boxes, type };
}
